/* eslint-disable no-prototype-builtins */
import SchoolsSerializer from './base';

export default class Group extends SchoolsSerializer {
  normalizeResponse(store, primaryModelClass, payload, id, requestType) {
    // ListGroups returns an empty object if there are no results.
    // Ember Data doesn't like that - inject an empty array to appease it.
    switch (requestType) {
      case 'query':
      case 'findAll':
        if (!payload.hasOwnProperty('groups')) {
          payload.groups = [];
        }
        break;
    }

    return super.normalizeResponse(...arguments);
  }
}
